import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Drawer, Field, inputCls, money } from "../team/shared";
import { PayoutPanel } from "./PayoutPanel";

export function MemberForm({ member, tools, onClose, onSaved, onChange }) {
  const isNew = !member;
  const [f, setF] = useState(member ? { ...member, password: "" } : { name: "", email: "", password: "", phone: "", share_pct: 30, image_limit: 20, tools: tools.map((t) => t.value) });
  const [clients, setClients] = useState([]);
  useEffect(() => {
    if (member) client.get(`/partners/${member.id}/clients`).then(({ data }) => setClients(data)).catch(() => {});
  }, [member]);
  const toggle = (t) => setF({ ...f, tools: f.tools.includes(t) ? f.tools.filter((x) => x !== t) : [...f.tools, t] });
  const save = async () => {
    const body = { name: f.name, phone: f.phone, share_pct: Number(f.share_pct), image_limit: Number(f.image_limit), tools: f.tools };
    try {
      if (isNew) await client.post("/partners", { ...body, email: f.email, password: f.password });
      else await client.patch(`/partners/${member.id}`, { ...body, ...(f.password ? { password: f.password } : {}) });
      toast.success("Saved"); onSaved();
    } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Drawer title={isNew ? "New Team Partner" : f.name} onClose={onClose} testid="partner-drawer">
      <div className="space-y-3 mb-5">
        <Field label="Name"><input data-testid="partner-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inputCls} /></Field>
        {isNew && <Field label="Email (login)"><input data-testid="partner-email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inputCls} /></Field>}
        <Field label={isNew ? "Password" : "Reset password (optional)"}><input data-testid="partner-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={inputCls} /></Field>
        <Field label="Phone"><input data-testid="partner-phone" value={f.phone || ""} onChange={(e) => setF({ ...f, phone: e.target.value })} className={inputCls} /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Commission share %"><input data-testid="partner-share" type="number" min="0" max="100" value={f.share_pct} onChange={(e) => setF({ ...f, share_pct: e.target.value })} className={`${inputCls} font-mono`} /></Field>
          <Field label="Images / day"><input data-testid="partner-image-limit" type="number" min="0" value={f.image_limit} onChange={(e) => setF({ ...f, image_limit: e.target.value })} className={`${inputCls} font-mono`} /></Field>
        </div>
      </div>
      <div className="text-[11px] uppercase tracking-widest text-slate-500 mb-2">Tool Access</div>
      <div className="grid grid-cols-2 gap-1.5 mb-5">
        {tools.map((t) => (
          <label key={t.value} data-testid={`partner-tool-${t.value}`} className="flex items-center gap-2 px-2.5 py-2 surface cursor-pointer surface-hover transition-colors duration-200">
            <input type="checkbox" checked={f.tools.includes(t.value)} onChange={() => toggle(t.value)} className="accent-[color:var(--gold)]" />
            <span className="text-xs text-slate-200">{t.label}</span>
          </label>
        ))}
      </div>
      <button data-testid="partner-save-btn" onClick={save} className="btn-gold w-full py-2.5 text-sm mb-6">{isNew ? "Create Partner" : "Save Changes"}</button>
      {!isNew && (
        <>
          <PayoutPanel memberId={member.id} onChange={onChange} />
          <div className="text-[11px] uppercase tracking-widest text-slate-500 mb-2">Clients ({clients.length})</div>
          {clients.map((c) => (
            <div key={c.id} className="flex items-center gap-2 text-sm py-1.5 border-b border-[color:var(--border-subtle)]">
              <span className="text-white">{c.name}</span><span className="text-xs text-slate-500">{c.broker} · {c.service}</span>
              <span className="ml-auto font-mono text-xs text-gold">{c.mt5_id}</span><span className="font-mono text-xs text-slate-400">{money(c.funding)}</span>
            </div>
          ))}
        </>
      )}
    </Drawer>
  );
}
